import { useEffect, useState } from 'react';

import { Link } from 'react-router-dom';
import { ROUTES } from '../Routes';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consentGiven = sessionStorage.getItem('cookieConsentGiven');
    
    if (!consentGiven) {
      setIsVisible(true);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    sessionStorage.setItem('cookieConsentGiven', 'true');
  };

  const dialogClassName = `osano-cm-window__dialog osano-cm-dialog osano-cm-dialog--position_bottom osano-cm-dialog--type_bar ${isVisible ? '' : 'osano-cm-dialog--hidden'}`;

  return (
    <div 
      role="dialog" 
      id="56b5c3b7-911d-415a-a973-3b1168b01390" 
      aria-label="Cookie Consent Banner" 
      aria-describedby="56b5c3b7-911d-415a-a973-3b1168b01390__label" 
      className={dialogClassName}
    >
      <button 
        className="osano-cm-dialog__close osano-cm-close" 
        onClick={handleClose} 
        aria-label="Close this dialog"
      >
        <svg width="20px" height="20px" viewBox="0 0 20 20" role="img">
          <line role="presentation" x1="2" y1="2" x2="18" y2="18"></line>
          <line role="presentation" x1="2" y1="18" x2="18" y2="2"></line>
        </svg>
      </button>

      <div className="osano-cm-dialog__content osano-cm-content">
        <span id="56b5c3b7-911d-415a-a973-3b1168b01390__label" className="osano-cm-content__message osano-cm-message">
          This website utilises technologies such as cookies to enable essential site functionality, as well as for analytics, personalisation, and targeted advertising. To learn more, view the following link:
        </span>
        <Link 
          rel="noopener noreferrer" 
          tabIndex={0} 
          to={ROUTES.PRIVACY_POLICY}
          target="_blank" 
          className="osano-cm-storage-policy osano-cm-content__link osano-cm-link"
        >
          Cookie Policy
        </Link>
      </div>

      <div className="osano-cm-dialog__buttons osano-cm-buttons">
        <button 
          className="osano-cm-manage osano-cm-buttons__button osano-cm-button osano-cm-button--type_manage" 
          tabIndex={0}
          onClick={handleClose}
        >
          Manage Preferences
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;